import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  RepairMaterialDto,
  RepairMaterialReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import RepairMaterialInline, { RepairMaterialInlineProps } from "./RepairMaterialInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: RepairMaterialDto | RepairMaterialReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<RepairMaterialInlineProps>;
}

export default function RepairMaterialLink({
  entity,
  entityId,
  inlineProps,
  ...otherProps
}: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.RepairCatalogRead]}
      to={ROUTE_PATH.REPAIR_MATERIAL_VIEW(entity?.id || entityId || "")}
      content={<RepairMaterialInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
